import { render, staticRenderFns } from "./prestamoEdit.vue?vue&type=template&id=bb1fe5fa"
import script from "./prestamoEdit.vue?vue&type=script&lang=js"
export * from "./prestamoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports